import { isDevEnv, isProdEnv } from "utils";
import { put } from "redux-saga/effects";
import { displayError } from "./general.actions";

export function* globalErrorHandlerSaga(
    // eslint-disable-next-line
    error: any,
    message = "Unexpected error occurred. Please check logs for details"
): Generator {
    if (isDevEnv) {
        console.error(error.payload.stack);
    }

    // TODO: should be sent somewhere trough http
    if (isProdEnv) {
        console.error(error);
    }

    yield put(displayError({ message }));
}
